module.exports = __webpack_public_path__ + "img/geranium-bg.85823918.jpg";